module.exports = __webpack_public_path__ + "static/media/f_hairstyle_frizzy_short_back.4b8d8cd7.png";